import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { RouteGuard } from '@hubio/hubio-login';
import { PoliciesInForceComponent } from './pages/policies-in-force/policies-in-force.component';
import { Communic8DownloadComponent } from './components/communic8-download/communic8-download.component';


const routes: Routes = [
  {
    path: 'policies',
    component: SearchResultsComponent
  },
  {
    path: 'analytics',
    component: AnalyticsComponent,
    canActivate: [RouteGuard],
    data: {
      allowedGroups: [
        'c8-role-admin'
      ]
    }
  },
  {
    path: 'policies-in-force',
    component: PoliciesInForceComponent,
    canActivate: [RouteGuard],
    data: {
      allowedGroups: [
        'c8-role-pif-user'
      ]
    }
  },
  {
    path: 'download',
    component: Communic8DownloadComponent,
    // canActivate: [RouteGuard],
    // data: {
    //   allowedGroups: [
    //     'c8-role-download'
    //   ]
    // }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
